// AIInput.js

import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  chatInputStreamAction,
  StartNewChatSessionAction,
  ContinueChatSessionAddSessionIDToReduxAction,
  FetchChatSessionsAction,
  hasClicked,
  hasNotClicked,
  AddAIModelToRedux,
} from "../../../Actions/AI";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";
import { Send, Loader2 } from "lucide-react";

class AIInput extends Component {
  state = {
    message: "",
  };

  static propTypes = {
    chatInputStreamAction: PropTypes.func.isRequired,
    continueChatSessionId: PropTypes.number,
    isNewChatSession: PropTypes.bool,
    isContinueChatSessionIdAddedToRedux: PropTypes.bool,
    navigate: PropTypes.func.isRequired,
    FetchChatSessionsAction: PropTypes.func.isRequired,
    StartNewChatSessionAction: PropTypes.func.isRequired,
    ContinueChatSessionAddSessionIDToReduxAction: PropTypes.func.isRequired,
    isClicked: PropTypes.bool,
    isChatStreaming: PropTypes.bool,
    model: PropTypes.string,
    moduleName: PropTypes.string,
  };

  handleInputChange = (event) => {
    this.setState({ message: event.target.value });
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey && !this.props.isClicked) {
      event.preventDefault();
      this.handleSendClick();
    }
  };

  handleSendClick = () => {
    const { message } = this.state;
    if (this.props.isClicked || !message.trim()) return;

    const {
      continueChatSessionId,
      chatInputStreamAction,
      isNewChatSession,
      StartNewChatSessionAction,
      ContinueChatSessionAddSessionIDToReduxAction,
      navigate,
      FetchChatSessionsAction,
      location,
    } = this.props;

    this.setState({ message: "" });

    if (isNewChatSession && !continueChatSessionId) {
      StartNewChatSessionAction()
        .then((data) => {
          if (data && data.id) {
            ContinueChatSessionAddSessionIDToReduxAction(data.id);
            navigate(`/dashboard/ai-chatbot/${data.id}`);
            chatInputStreamAction(message, data.id);
            FetchChatSessionsAction();
          }
        })
        .catch((error) => {
          console.error("Error starting new chat session:", error);
        });
    } else if (continueChatSessionId && !isNewChatSession) {
      const path = location?.pathname?.split("/");
      const id = path[path.length - 1];
      if (id) {
        chatInputStreamAction(message, id);
      }
    }
  };

  render() {
    const { message } = this.state;
    const isButtonDisabled = this.props.isClicked || message.trim() === "";

    return (
      <div className="w-full flex flex-col gap-2">
        <div className="relative w-full">
          <input
            type="text"
            value={message}
            onChange={this.handleInputChange}
            onKeyDown={this.handleKeyDown}
            disabled={this.props.isClicked}
            className="w-full h-12 md:h-14 text-sm md:text-base rounded-full border border-transparent bg-[radial-gradient(circle_at_top_left,#e0edff,transparent_55%),linear-gradient(180deg,#ffffff_0%,#f3f6ff_100%)] shadow-[0_10px_30px_rgba(15,23,42,0.10)] focus:outline-none focus:ring-2 focus:ring-primary-blue/70 focus:ring-offset-0 pl-5 pr-32 transition-all placeholder:text-gray-400"
            placeholder="Chat with CESGPT"
          />
          <button
            onClick={this.handleSendClick}
            disabled={isButtonDisabled}
            className={`absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-2 px-4 h-9 rounded-full bg-primary-blue text-white text-sm font-medium transition-opacity ${
              isButtonDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-700"
            }`}
          >
            {this.props.isClicked ? (
              <>
                <Loader2 className="w-3.5 h-3.5 animate-spin" />
                <span className="hidden sm:inline">Thinking</span>
              </>
            ) : (
              <>
                <span className="hidden sm:inline">Send</span>
                <Send className="w-3.5 h-3.5" />
              </>
            )}
          </button>
        </div>
        <p className="text-xs text-gray-400 text-center">
          All data exchange is safe with us.{" "}
          <Link to="/learn-more" className="text-primary-blue hover:underline">
            Learn more
          </Link>
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  continueChatSessionId: state.ai.continueChatSessionId,
  isNewChatSession: state.ai.isNewChatSession,
  isContinueChatSessionIdAddedToRedux: state.ai.isContinueChatSessionIdAddedToRedux,
  isClicked: state.ai.isClicked,
  isChatStreaming: state.ai.isChatStreaming,
  model: state.ai.model,
  moduleName: state.ai.modelName,
});

export default withRouterHooks(
  connect(mapStateToProps, {
    chatInputStreamAction,
    StartNewChatSessionAction,
    ContinueChatSessionAddSessionIDToReduxAction,
    FetchChatSessionsAction,
    hasClicked,
    hasNotClicked,
    AddAIModelToRedux,
  })(AIInput)
);
